export default __webpack_public_path__ + "static/media/learners.9803e12f.svg";